import type { ComponentType, SVGProps } from 'react';
import { cn } from '@/lib/cn';

export type HeroiconComponent = ComponentType<SVGProps<SVGSVGElement>>;

export interface IconProps {
  icon: HeroiconComponent;
  size?: 16 | 20 | 24;
  className?: string;
  /** Required when icon is sole content of an interactive control. */
  label?: string;
  /** Default true — icon is decorative when inside a labeled control. */
  decorative?: boolean;
}

const sizeClasses: Record<NonNullable<IconProps['size']>, string> = {
  16: 'h-4 w-4',
  20: 'h-5 w-5',
  24: 'h-6 w-6',
};

export function Icon({
  icon: IconComponent,
  size = 20,
  className,
  label,
  decorative = true,
}: IconProps) {
  const isDecorative = decorative && !label;

  return (
    <IconComponent
      className={cn(sizeClasses[size], 'shrink-0', className)}
      aria-hidden={isDecorative ? true : undefined}
      aria-label={!isDecorative ? label : undefined}
      role={!isDecorative ? 'img' : undefined}
    />
  );
}
